export default {
  auth: {
    magic: process.env.GATSBY_OPTIONS_MAGIC_API_KEY
      ? { apiKey: process.env.GATSBY_OPTIONS_MAGIC_API_KEY }
      : null,
    stytch: process.env.GATSBY_PUBLIC_STYTCH_API_KEY
      ? {
          apiKey: process.env.GATSBY_PUBLIC_STYTCH_API_KEY,
          redirectPath:
            process.env.GATSBY_PUBLIC_STYTCH_REDIRECT_PATH ?? '/authenticate',
          sessionDurationMinutes: parseInt(
            process.env.GATSBY_PUBLIC_STYTCH_SESSION_DURATION ?? 60
          ),
        }
      : null,
  },
}
